import React, { Component } from "react";
import { Field, reduxForm } from "redux-form";
import { TextField } from "redux-form-material-ui";
import { Card, CardText } from "material-ui/Card";
import { connect } from "react-redux";
import { RaisedButton, FlatButton } from "material-ui";
import { required, requiredNoUnderscore } from "../../common/validaciones";
import {
	MODE_CRU_CREATE,
	MODE_CRU_UPDATE,
	MODE_CRU_SHOW
} from "../../actions/ActionConstants";
import { ROL_ADMIN, ROL_SUB_ADMIN } from "../../common/Constants";
import { PAYMENT_METHODS } from "../../config/RoutesConstants";
import Util, { SUCCESS } from "../../common/Util";
import UtilPC from "../../common/UtilPC";
import {
	actionCreatePaymentMethod,
	actionUpdatePaymentMethod
} from "../../actions/PaymentMethodActions";
import InputMask from "../../components/InputMask/InputMask";

class PaymentMethodForm extends Component {
	constructor(props) {
		super(props);
		let state =
			this.props.modeCRU === MODE_CRU_SHOW ? { enableField: true } : {};
		this.state = state;
		this.returnOnSubmit = this.returnOnSubmit.bind(this);
	}

	componentWillMount() {
		if (
			!this.props.modeCRU ||
			(this.props.rol !== ROL_ADMIN && this.props.rol !== ROL_SUB_ADMIN)
		)
			this.props.history.push(PAYMENT_METHODS);
		else if (
			this.props.modeCRU === MODE_CRU_UPDATE ||
			this.props.modeCRU === MODE_CRU_SHOW
		)
			this.props.initialize(this.props.paymentMethod);
	}

	onSubmit(values) {
		if (this.props.modeCRU === MODE_CRU_CREATE)
			this.props.actionCreatePaymentMethod(values, this.returnOnSubmit);
		else if (this.props.modeCRU === MODE_CRU_UPDATE)
			this.props.actionUpdatePaymentMethod(values, this.returnOnSubmit);
	}

	returnOnSubmit(response) {
		if (this.props.modeCRU === MODE_CRU_CREATE) {
			if (response === SUCCESS) {
				Util.showNoty(SUCCESS, "Forma de pago creada");
				this.props.history.push(PAYMENT_METHODS);
			}
		} else if (this.props.modeCRU === MODE_CRU_UPDATE) {
			if (response === SUCCESS) {
				Util.showNoty(SUCCESS, "Forma de pago modificada");
				this.props.history.push(PAYMENT_METHODS);
			}
		}
	}

	render() {
		const { handleSubmit } = this.props;
		return (
			<div className="center">
				<Card className="card">
					{UtilPC.renderCardTitleCRU(this.props.modeCRU, "Forma de Pago")}
					<CardText>
						<form>
							<div className="content-papercard">
								<Field
									name="name"
									component={TextField}
									floatingLabelText="Nombre"
									validate={[required]}
									floatingLabelFixed={false}
									disabled={this.state.enableField}
								/>
								<Field
									name="agreement"
									component={InputMask}
									validate={requiredNoUnderscore}
									floatingLabelText="Número de convenio"
									mask={[/\d/, /\d/, /\d/, /\d/]}
									floatingLabelFixed={false}
									disabled={this.state.enableField}
								/>
							</div>
							<div>
								<FlatButton
									label="Cancelar"
									onClick={() => this.props.history.push(PAYMENT_METHODS)}
									style={{ margin: 5 }}
								/>
								<RaisedButton
									label="Aceptar"
									disabled={this.state.enableField}
									primary
									style={{ margin: 5 }}
									onClick={handleSubmit(this.onSubmit.bind(this))}
								/>
							</div>
						</form>
					</CardText>
				</Card>
			</div>
		);
	}
}

function mapStateToProps(store) {
	return {
		paymentMethod: store.paymentMethod.paymentMethod,
		modeCRU: store.paymentMethod.modeCRU,
		rol: store.app.rol
	};
}

export default reduxForm({
	form: "PaymentMethodForm"
})(
	connect(mapStateToProps, {
		actionCreatePaymentMethod,
		actionUpdatePaymentMethod
	})(PaymentMethodForm)
);



// WEBPACK FOOTER //
// ./src/screens/PaymentMethod/PaymentMethodForm.js